import Axios from 'axios';
import { logoutUrl } from 'constants/links';
import { setLogout } from 'redux/slices/usersSlice';
import store from 'redux/store';

export const amsAxios = Axios.create({
  timeout: 60000,
  withCredentials: true,
});

const responseHandler = (response) => {
  return response;
};

const errorResponseHandler = (error) => {
  console.log(error?.response?.data);
  console.log('[ERROR] AMS Axios receive the unexpected problem:>> ', error);
  if (error.response?.status === 401) {
    store.dispatch(setLogout(true));
    window.location.replace(logoutUrl);
  }

  return Promise.reject(error);
};

amsAxios?.interceptors?.response?.use(
  (response) => responseHandler(response),
  (error) => errorResponseHandler(error)
);
